import { render, staticRenderFns } from "./ThreatFilter.vue?vue&type=template&id=23086bf4&"
import script from "./ThreatFilter.vue?vue&type=script&lang=js&"
export * from "./ThreatFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports